import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.agent');
@Component({
    selector: 'wiz-page-agent',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.agent/view.scss */
:host {
  display: none;
}`],
})
export class PageAgentComponent {}

export default PageAgentComponent;